
import { TranslateLoader } from '@codeandweb/ngx-translate';
import { Observable } from 'rxjs';

export class CustomTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    return new Observable(observer => {
        fetch(`/i18n/${lang}.json`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Could not load translations for ${lang}`);
                }
                return response.json();
            })
            .then(data => {
                observer.next(data);
                observer.complete();
            })
            .catch(error => {
                observer.error(error);
            });
    });
  }
}
